var Toggles = {
    bindToggles: ['aside', 'content'],
    aside: {
        selector: '[data-toggle="aside"]',
        trigger: 'click',
        callback: function(elem) {
            var $elem = $(elem),
                $target = $($elem.data('target'));

            $target.toggleClass('active');
        }
    },
    content: {
        selector: '[data-toggle="content"]',
        trigger: 'click, change',
        callback: function(elem) {
            var $elem = $(elem),
                $target = $($elem.data('target')),
                $parent = $($elem.data('parent'));

            $parent
                .find('.toggle-content')
                .hide();
            $target.show();
        }
    },
    initialize: function() {
        var $this = this;

        for(var i = 0; i < $this.bindToggles.length; i++) {
            var toggle = $this.bindToggles[i];

            $('body').delegate($this[toggle].selector, $this[toggle].trigger, function() {
                $this[$(this).data('toggle')].callback(this);

                return false;
            });
        }
    }
};

$(function() {
    Toggles.initialize();
});
